import React from 'react';
import MyFilesView from './MyFilesView';

const MyFilesViewController = () => {
    return <MyFilesView />
}

export default MyFilesViewController;